import React from 'react'

export const BeListApiContext = React.createContext({ apiContext: null })
